import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Card} from '@jobseeker/lotus/lib/components';
import {Facebook, LinkedIn, Twitter} from '@jobseeker/lotus/lib/assets/icons';
import {Link} from '@mui/material';
import {useSelector, shallowEqual} from 'react-redux';
import {useInterceptor} from '@jobseeker/common-core';
import Image from 'next/image';
import {InterceptorType} from './types';
import {Paragraph} from '@jobseeker/lotus/lib/elements';
import InjectSearchOverlay from '@components/SearchInjection';

import type {AppState} from '@jobseeker/common-core/lib/types';

const AboutUs = () => {
  const interceptor: InterceptorType = useInterceptor();
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const {
    footer: {socialLinks},
  } = interceptor;

  const SOCIAL_MEDIA_SRC: {[key: string]: string} = {
    linkedin: isAppIimjobs
      ? LinkedIn
      : 'https://job-static.hirist.com/V8/static/media/linkedin-icon.83a9eb42.svg',
    facebook: isAppIimjobs
      ? Facebook
      : 'https://job-static.hirist.com/V8/static/media/fb-icon.9a471ab6.svg',
    twitter: isAppIimjobs
      ? Twitter
      : 'https://job-static.hirist.com/V8/static/media/twitter-icon.b08b5a4c.svg',
  };

  const isSearchEnabled = useSelector(
    (state: AppState) => state.app.layout.searchOverlay,
    shallowEqual
  );

  const currentYear = new Date().getFullYear();
  const PORTAL = `${process.env.NEXT_PUBLIC_APP_NAME}`;
  const DOMAIN = `${process.env.NEXT_PUBLIC_APP_DOMAIN}`;
  return isAppIimjobs ? (
    <Box
      sx={{
        maxWidth: '1050px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
      <Card variant="" heading="">
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '30px',
            textAlign: 'Center',
            color: 'secondary.dark',
            marginBottom: '40px',
          }}
        >
          ABOUT US
        </Typography>
        <Paragraph
          title=""
          body={
            <>
              <i>
                <b>
                  &quot;So many of our dreams at first seem impossible, then
                  they seem improbable, and then, when we summon the will, they
                  soon become inevitable.&quot;
                </b>
              </i>
            </>
          }
        />
        <Paragraph
          title=""
          body={
            <>
              It starts with a seed of an idea. Then that seed germinates into a
              thought. And finally, that thought begins to grow in your mind
              like a tree seeking sunshine!
            </>
          }
        />
        <Paragraph
          title=""
          body={
            <>
              It was with a similar idea that {PORTAL} was born and now that
              idea has grown into a platform that helps jobseekers connect with
              their dream job. We&apos;ve connected with over 13,00,000
              jobseekers already and this is just the beginning...
            </>
          }
        />
        <Paragraph
          title=""
          body={
            <>
              We feature{' '}
              <Typography
                component={'span'}
                sx={{
                  textDecoration: 'line-through',
                }}
              >
                some of
              </Typography>{' '}
              the best jobs in{' '}
              <b>
                Banking & Finance, Consulting, Research & Analytics, Sales &
                Marketing, HR, IT and Operations.
              </b>
            </>
          }
        />
        <Paragraph
          title=""
          body={
            <>
              We&apos;re a team of{' '}
              <b> thinkers, creators, technologists and mavericks </b> but most
              importantly, we&apos;re a team of <b>doers!</b>
              <br />
              We are young, we&apos;re passionate and we&apos;re shaking up the
              recruitment space in India.
            </>
          }
        />
        <Paragraph title="" body="" />
        <Paragraph title="" body="You should connect with us. Seriously!" />
        <Box>
          {socialLinks.map((socialMediaInfo, index) => (
            <Link
              key={index}
              href={socialMediaInfo.url}
              target="_blank"
              sx={{marginRight: '8px', display: 'inline-block'}}
            >
              <Image
                src={SOCIAL_MEDIA_SRC[socialMediaInfo.title]}
                alt={socialMediaInfo.title}
                width={30}
                height={30}
              />
            </Link>
          ))}
        </Box>
        <Paragraph
          title=""
          body={
            <>
              {DOMAIN} &#169; {currentYear}. All rights reserved.
            </>
          }
        />
      </Card>
    </Box>
  ) : (
    <Box
      sx={{
        mt: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 400,
        padding: {xxs: '12px 10px', md: '40px 30px', lg: '40px 50px'},
        marginTop: '0px',
      }}
    >
      <Card
        variant=""
        heading=""
        sx={{
          pt: {
            md: 2.5,
            xs: 2.25,
          },
          pb: {
            md: 6.625,
            xs: 2.25,
          },
          px: {
            md: 3.125,
            xs: 1.5,
          },
          borderRadius: !isAppIimjobs ? '8px' : '15px',
          width: !isAppIimjobs ? '100%' : 'inherit',

          padding: '20px',
          minHeight: '70vh',
        }}
      >
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',
              fontWeight: 'bold',
              lineHeight: '24px',
            }
          }
          title=""
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
            }
          }
          body={
            <>
              &quot;So many of our dreams at first seem impossible, then they
              seem improbable, and then, when we summon the will, they soon
              become inevitable.&quot;
            </>
          }
        />
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',

              lineHeight: '24px',
            }
          }
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
              fontWeight: 'bold',
            }
          }
          title=""
          body={
            <>
              It starts with a seed of an idea. Then that seed germinates into a
              thought. And finally, that thought begins to grow in your mind
              like a tree seeking sunshine!
            </>
          }
        />
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',

              lineHeight: '24px',
            }
          }
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
              fontWeight: 'bold',
            }
          }
          title=""
          body={
            <>
              <p>
                It was with a similar idea that hirist was born and now that
                idea has grown into a platform that helps jobseekers connect
                with their dream job. We&apos;ve connected with over 13,00,000
                jobseekers already and this is just the beginning...
              </p>
            </>
          }
        />
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',

              lineHeight: '24px',
            }
          }
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
              fontWeight: 'bold',
            }
          }
          title=""
          body={
            <>
              We feature <del>some of</del> the best jobs in Banking &amp;
              Finance, Consulting, Research &amp; Analytics, Sales &amp;
              Marketing, HR, IT and Operations.
            </>
          }
        />
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',

              lineHeight: '24px',
            }
          }
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
              fontWeight: 'bold',
            }
          }
          title=""
          body={
            <>
              We&apos;re a team of thinkers, creators, technologists and
              mavericks but most importantly, we&apos;re a team of doers!
            </>
          }
        />
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',

              lineHeight: '24px',
            }
          }
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
              fontWeight: 'bold',
            }
          }
          title=""
          body={
            <>
              We are young, we&apos;re passionate and we&apos;re shaking up the
              recruitment space in India.
            </>
          }
        />
        <Paragraph
          style={
            !isAppIimjobs && {
              fontSize: '16px',

              lineHeight: '24px',
            }
          }
          titleStyle={
            !isAppIimjobs && {
              fontSize: '15px',
              fontWeight: 'bold',
            }
          }
          title=""
          body={<>You should connect with us. Seriously!</>}
        />
        <Box>
          {socialLinks.map((socialMediaInfo, index) => (
            <Link
              key={index}
              href={socialMediaInfo.url}
              target="_blank"
              sx={{
                marginRight: isAppIimjobs ? '8px' : '20px',
                display: 'inline-block',
              }}
            >
              <Image
                src={SOCIAL_MEDIA_SRC[socialMediaInfo.title]}
                alt={socialMediaInfo.title}
                width={isAppIimjobs ? 30 : 42}
                height={isAppIimjobs ? 30 : 42}
              />
            </Link>
          ))}
        </Box>
      </Card>
    </Box>
  );
};

export default AboutUs;
